import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';

import StringUtils from '../../utils/StringUtils';

import { MultipleLineTruncate } from '../../common/LineTruncate';
import css from './BooksStaffDescription.module.scss';

interface DescriptionOwnProps {
  text: string;
}
type DescriptionProps = DescriptionOwnProps & InjectedIntlProps;
const BooksStaffDescription = (props: DescriptionProps) => {
  const [ellipsis, setEllipsis] = React.useState(true);
  const [clampedState, setClampedState] = React.useState(true);

  return (
    <div className={css.BooksStaffDescription}>
      {ellipsis ? (
        <MultipleLineTruncate
          className={css.BooksStaffDescription__Body}
          maxLine={3}
          onReflow={({ clamped }) => setClampedState(!!clamped)}
          text={props.text}
        />
      ) : (
        <div className={css.BooksStaffDescription__Body}>
          {StringUtils.nl2br(props.text)}
        </div>
      )}
      {clampedState && (
        <button
          className={css.BooksStaffDescription__TruncateButton}
          onClick={ev => {
            ev.preventDefault();
            setEllipsis(!ellipsis);
          }}
        >
          {ellipsis
            ? props.intl.formatMessage({ id: 'books.booksMenu.truncateOpen' })
            : props.intl.formatMessage({ id: 'books.booksMenu.truncateClose' })}
        </button>
      )}
    </div>
  );
};

export default injectIntl(BooksStaffDescription);
